export const emodji = () => {
  const arEmodjies = document.querySelectorAll('.about__emodj-list-item')

  arEmodjies.forEach((element) => {
    element.addEventListener('click', function (e) {
      e.preventDefault()
      element.classList.toggle('active')
    })
  })
}
